import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { Role } from 'src/features/roles/utils/types';

const RESOURCE = '/users/role/:roleId/';

type QueryFnType = typeof queryFn;

interface DTO {
    roleId: string;
}
const queryFn = ({ roleId }: DTO): Promise<Role> => {
    return axios.get(formatResourcePath(RESOURCE, { roleId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetRole, RESOURCE as GET_ROLE_RESOURCE };
